"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
import { Component, Vue, Ref } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { Debounce } from "vue-debounce-decorator";
import ChangeModeDialog from "../dialogs/ChangeModeDialog.vue";
let RegulatorySettings = class extends Vue {
  constructor() {
    super(...arguments);
    this.isShowRegulationStatus = true;
    this.isOpenAllSensitiveWebRegulation = true;
    this.regulationMode = "SHOP";
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v1/regulation-sensitive-webpages")
    );
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getMoreSettings();
      yield this.gridController.search();
    });
  }
  getMoreSettings() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/regulation-config`);
        this.isShowRegulationStatus = response.data.isShowRegulationStatus;
        this.isOpenAllSensitiveWebRegulation = response.data.isOpenAllSensitiveWebRegulation;
        this.regulationMode = response.data.regulationMode;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeMode() {
    return __async(this, null, function* () {
      yield this._changeModeDialog.open(this.regulationMode);
    });
  }
  realChangeMode() {
    return __async(this, null, function* () {
      try {
        if (this.regulationMode === "SHOP") {
          yield API.post(`api://base.auth/api/v1/regulation-mode/USER`);
          this.$emit("changemode", "USER");
        } else {
          yield API.post(`api://base.auth/api/v1/regulation-mode/SHOP`);
          this.$emit("changemode", "SHOP");
        }
        yield this.getMoreSettings();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeRecodingOpen() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.auth/api/v1/regulation-status-show/${this.isShowRegulationStatus ? "enable" : "disable"}`);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeSensitiveLog() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.auth/api/v1/regulation-sensitive-webpages/all/${this.isOpenAllSensitiveWebRegulation ? "enable" : "disable"}`);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  handleUrlOpenorClose(row) {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.auth/api/v1/regulation-sensitive-webpages/${row.id}/${row.open ? "enable" : "disable"}`);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("changeModeDialog")
], RegulatorySettings.prototype, "_changeModeDialog", 2);
__decorateClass([
  Debounce(400)
], RegulatorySettings.prototype, "changeRecodingOpen", 1);
__decorateClass([
  Debounce(400)
], RegulatorySettings.prototype, "changeSensitiveLog", 1);
__decorateClass([
  Debounce(400)
], RegulatorySettings.prototype, "handleUrlOpenorClose", 1);
RegulatorySettings = __decorateClass([
  Component({
    components: {
      UiGrid,
      ChangeModeDialog
    }
  })
], RegulatorySettings);
export {
  RegulatorySettings as default
};
